export default "__VITE_ASSET__0c9fc55c__"